import { CloudUpload as CloudUploadIcon } from "@mui/icons-material";
import { Box, styled, Typography } from "@mui/material";

export const DropzoneContainer = styled(Box)(() => ({
  backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23ADACB0FF' stroke-width='2' stroke-dasharray='10' stroke-dashoffset='4' stroke-linecap='square'/%3e%3c/svg%3e")`,
  borderRadius: "8px",
  height: "224px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  textAlign: "center",
  backgroundColor: "#f9f9f9",
  color: "#333",
  margin: "10px 0px",
  fontFamily: "Arial, sans-serif",
  transition: "background-color 0.3s ease",

  "&.active": {
    backgroundColor: "#ffcccc",
    borderColor: "#ff0000",
  },
}));

export const IconContainer = styled(Box)(() => ({
  backgroundColor: "#05222324",
  width: "44px",
  height: "44px",
  margin: "0px auto 10px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#424D4D",
}));

export const StyledIcon = styled(CloudUploadIcon)(() => ({
  fontSize: "48px",
  color: "#888",
}));

export const DropzoneText = styled(Typography)(() => ({
  marginBottom: "10px",
  height: "224px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const DropzoneSmallText = styled(Typography)(() => ({
  fontSize: "12px",
  color: "#8E9494",
  fontFamily: " inter",
}));
